(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[276],{

/***/ 6317:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grievance-policy",
      function () {
        return __webpack_require__(2739);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7274);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_metaConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7202);
// Modules



// Styles

// Constants

var Footer = function() {
    var items = [
        {
            label: "FAQ",
            route: "/faq"
        },
        {
            label: "Contact Us",
            route: "/contact-us"
        },
        {
            label: "Privacy Policy",
            route: "/privacy-policy"
        },
        {
            label: "Terms of Service",
            route: "/terms-of-service"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footerWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "pagePad__x",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footer),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex--1",
                            style: {
                                maxWidth: 360
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "cursor--pointer",
                                        src: "/assets/icons/logoFull.svg?v=2",
                                        alt: "NamasPay logo",
                                        style: {
                                            height: 32
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "fontSize--h4 color--secondary marginTop--l3",
                                    style: {
                                        lineHeight: 1.5
                                    },
                                    children: _constants_metaConstants__WEBPACK_IMPORTED_MODULE_3__/* .META_INFO.LONG_DESC */ .f.LONG_DESC
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex--1 padLeft--l2",
                            style: {
                                maxWidth: 420,
                                color: "rgba(246, 246, 246, 1)"
                            },
                            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: item === null || item === void 0 ? void 0 : item.route,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "cursor--pointer display--block color--link ".concat(index > 0 ? "marginTop--l3" : "", " ").concat((_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footerLink)),
                                        children: item === null || item === void 0 ? void 0 : item.label
                                    })
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        height: 1,
                        background: "rgba(255,255,255,0.1)",
                        marginTop: 80,
                        marginBottom: 80
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text__align--center color--secondary fontSize--h5 marginTop--l10",
                    children: "\xa9 Copyright 2023 Triotech Ltd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text__align--center color--secondary fontSize--h5 marginTop--l1",
                    children: "All rights reserved"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 9533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7274);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _elements_CTA__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1461);
/* harmony import */ var _utils_helperFunctions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8365);
// Modules



// Styles

// Components

// Utils

var Header = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBrowser = ref[0], setIsBrowser = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (true) setIsBrowser(true);
    }, []);
    var isDesktop = function() {
        if (!isBrowser) return true;
        var isMobile = "ontouchstart" in window; // likely mobile
        return !isMobile;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headerWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat((_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header), " pagePad__x"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "cursor--pointer",
                        src: "/assets/icons/logoFullBlack.svg",
                        alt: "NamasPay logo",
                        style: {
                            height: 56,
                            width: 296
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_CTA__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().downloadCTA),
                    type: "primary",
                    text: isDesktop() ? "Download Now" : "Download Now",
                    onAction: _utils_helperFunctions__WEBPACK_IMPORTED_MODULE_4__/* .onDownloadClick */ .No
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 1461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _CTA_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(653);
/* harmony import */ var _CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2__);
// Modules



// Styles

var CTA = function(param) {
    var className = param.className, type = param.type, leftImg = param.leftImg, text = param.text, rightImg = param.rightImg, onAction = param.onAction, disabled = param.disabled, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(className || "", " ").concat((_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default().customCta), " ").concat((_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[type] || "", " ").concat(disabled ? (_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : ""),
        style: style ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, style) : {},
        onClick: function() {
            if (onAction) onAction();
        },
        children: [
            leftImg,
            text,
            rightImg
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CTA);


/***/ }),

/***/ 2739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ GrievancePolicy; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-pdf/dist/esm/entry.js + 48 modules
var entry = __webpack_require__(2954);
// EXTERNAL MODULE: ./node_modules/react-pdf/dist/esm/Page/AnnotationLayer.css
var AnnotationLayer = __webpack_require__(270);
// EXTERNAL MODULE: ./components/Header.js
var Header = __webpack_require__(9533);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
;// CONCATENATED MODULE: ./components/GrievancePolicyUI.js
// Modules



// Styles

// Components


entry/* pdfjs.GlobalWorkerOptions.workerSrc */.v0.GlobalWorkerOptions.workerSrc = "//unpkg.com/pdfjs-dist@".concat(entry/* pdfjs.version */.v0.version, "/build/pdf.worker.min.js");
var GrievancePolicyUI = function() {
    var ref = (0,react.useState)(null), numPages = ref[0], setNumPages = ref[1];
    var ref1 = (0,react.useState)(1), pageNumber = ref1[0], setPageNumber = ref1[1];
    var ref2 = (0,react.useState)(800), pdfWidth = ref2[0], setPdfWidth = ref2[1];
    var ref3 = (0,react.useState)(1200), pdfHeight = ref3[0], setPdfHeight = ref3[1];
    (0,react.useEffect)(function() {
        if (true) {
            var width = window.innerWidth - 50 > 800 ? 800 : window.innerWidth - 50;
            setPdfWidth(width);
            setPdfHeight(width * 1.5);
        }
    }, []);
    var onDocumentLoadSuccess = function(param) {
        var numPages = param.numPages;
        setNumPages(numPages);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: "main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pad--l4 flex--center--center flex__flow--column",
                style: {
                    maxWidth: 800,
                    marginLeft: "auto",
                    marginRight: "auto"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "sectionHeading text__align--center",
                        children: "Grievance Policy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(entry/* Document */.BB, {
                        file: "/assets/privacy-policy.pdf",
                        options: {
                            cMapUrl: "https://unpkg.com/pdfjs-dist@".concat(entry/* pdfjs.version */.v0.version, "/cmaps/"),
                            cMapPacked: true
                        },
                        onLoadSuccess: onDocumentLoadSuccess,
                        height: 1300,
                        width: 800,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(entry/* Page */.T3, {
                            pageNumber: pageNumber,
                            height: pdfHeight,
                            width: pdfWidth
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "width--full display--flex flex__justifyContent--between fontSize--h5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                onClick: function() {
                                    return setPageNumber(function(prevState) {
                                        return prevState - 1;
                                    });
                                },
                                style: pageNumber === 1 ? {
                                    color: "rgba(0,0,0,0.5)",
                                    pointerEvents: "none"
                                } : {
                                    color: "rgba(0,0,0,1)",
                                    fontFamily: "met_bold"
                                },
                                children: [
                                    "<",
                                    " Prev"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    "Page ",
                                    pageNumber,
                                    " of ",
                                    numPages
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                onClick: function() {
                                    return setPageNumber(function(prevState) {
                                        return prevState + 1;
                                    });
                                },
                                style: pageNumber === numPages ? {
                                    color: "rgba(0,0,0,0.5)",
                                    pointerEvents: "none"
                                } : {
                                    color: "rgba(0,0,0,1)",
                                    fontFamily: "met_bold"
                                },
                                children: [
                                    "Next ",
                                    ">"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var components_GrievancePolicyUI = (GrievancePolicyUI);

// EXTERNAL MODULE: ./constants/metaConstants.js
var metaConstants = __webpack_require__(7202);
;// CONCATENATED MODULE: ./pages/grievance-policy.js
// Libraries




// Components

// Constants

function GrievancePolicy() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaConstants/* META_INFO.GRIEVANCE_POLICY_PAGE_TITLE */.f.GRIEVANCE_POLICY_PAGE_TITLE,
                        name: "twitter:title"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaConstants/* META_INFO.GRIEVANCE_POLICY_PAGE_URL */.f.GRIEVANCE_POLICY_PAGE_URL,
                        name: "twitter:url"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: metaConstants/* META_INFO.GRIEVANCE_POLICY_PAGE_TITLE */.f.GRIEVANCE_POLICY_PAGE_TITLE,
                canonical: metaConstants/* META_INFO.GRIEVANCE_POLICY_PAGE_URL */.f.GRIEVANCE_POLICY_PAGE_URL,
                openGraph: {
                    title: metaConstants/* META_INFO.GRIEVANCE_POLICY_PAGE_TITLE */.f.GRIEVANCE_POLICY_PAGE_TITLE,
                    url: metaConstants/* META_INFO.GRIEVANCE_POLICY_PAGE_URL */.f.GRIEVANCE_POLICY_PAGE_URL
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GrievancePolicyUI, {})
        ]
    });
};


/***/ }),

/***/ 7274:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"HomeUI_headerWrapper___nauh","header":"HomeUI_header__yQ7P7","downloadCTA":"HomeUI_downloadCTA__LNsRz","title":"HomeUI_title__2YcTz","desc":"HomeUI_desc__q_oUd","sec3Wrapper":"HomeUI_sec3Wrapper___igt3","sec3":"HomeUI_sec3__kotDB","comparisonContainer":"HomeUI_comparisonContainer__BnBHn","comparisonRow":"HomeUI_comparisonRow__HWCvn","col1":"HomeUI_col1__NPcZA","sec1":"HomeUI_sec1__Udx3W","details":"HomeUI_details__zHmRo","pageTitle":"HomeUI_pageTitle__DblKZ","storeImagesWrapper":"HomeUI_storeImagesWrapper__AsT_K","storeImg":"HomeUI_storeImg__cwF9n","img":"HomeUI_img__wr61b","sec2Wrapper":"HomeUI_sec2Wrapper__9F0Dp","sec2":"HomeUI_sec2__1oD_8","flagsAnimationContainer":"HomeUI_flagsAnimationContainer__0iL4g","flagsAnimation":"HomeUI_flagsAnimation__MI930","run":"HomeUI_run__zEBA4","welcomeToText":"HomeUI_welcomeToText__MPG2m","usageWidgetRow":"HomeUI_usageWidgetRow__r_9xq","usageWidget":"HomeUI_usageWidget__qhtob","upiFeaturesContainerWrapper":"HomeUI_upiFeaturesContainerWrapper__LdAM_","upiFeaturesContainer":"HomeUI_upiFeaturesContainer__6huwu","upiFeatureWidget":"HomeUI_upiFeatureWidget__f6AJt","featureImg":"HomeUI_featureImg__jkEbn","col2":"HomeUI_col2__3VpYf","col3":"HomeUI_col3__f3C0n","col4":"HomeUI_col4__KtU6j","safeMoneyContainer":"HomeUI_safeMoneyContainer__rKH36","sec4Wrapper":"HomeUI_sec4Wrapper__8p5Nc","sec4":"HomeUI_sec4__UNs6M","sectionHeading":"HomeUI_sectionHeading__v0wV_","imgsWrapper":"HomeUI_imgsWrapper__KCJXg","sec5Wrapper":"HomeUI_sec5Wrapper__ZSYE6","sec5":"HomeUI_sec5__ySaqh","sec5Widget":"HomeUI_sec5Widget__WubTd","imgWrapper":"HomeUI_imgWrapper__dWwzu","acrossCountryListWrapper":"HomeUI_acrossCountryListWrapper__NLWtP","acrossCountryList":"HomeUI_acrossCountryList__bwW1q","acrossCountryRun":"HomeUI_acrossCountryRun__JmtHx","sec6Wrapper":"HomeUI_sec6Wrapper__XXxDI","sec6":"HomeUI_sec6__IAkGG","widget":"HomeUI_widget__hLe1m","faqWrapper":"HomeUI_faqWrapper__8yi6e","faqContainer":"HomeUI_faqContainer__muFWf","faqWidget":"HomeUI_faqWidget__BIPpQ","supportContainer":"HomeUI_supportContainer__LUmWB","footerWrapper":"HomeUI_footerWrapper__Xa_Rg","footer":"HomeUI_footer__wvlfA","footerLink":"HomeUI_footerLink__HLbvS"};

/***/ }),

/***/ 653:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customCta":"CTA_customCta__k8Ay7","secondary":"CTA_secondary__hCi_W"};

/***/ }),

/***/ 4601:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 2767:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 8251:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 7677:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 7324:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [824,664,200,961,774,888,179], function() { return __webpack_exec__(6317); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);